import React, { useContext, useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { findAllDeleteRequests } from '../../models/actions/DeleteRequests';
import { removeUser } from '../../models/actions/Users';
import '../../App.css';
import compose from 'recompose/compose';
import SpIconAndTextButton from '../../components/atoms/SpIconAndTextButton';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import SpSearch from '../../components/atoms/SpSearch';
import { SpTable, SpTableCell, SpTableRow } from '../../components/bundles/SpTable';
import { styled } from '../../components/styled';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Grid, TableCell } from '@material-ui/core';
import { labels } from '../shared/translations';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import SpDialog from '../../components/atoms/SpDialog';
import { theme } from '../../components/theme';
import moment from 'moment';
import { UserSessionContext } from '../../App';

const UserDeletionRequests = (props) => {
  const [searchString, setSearchString] = useState();
  const [deleteRequestsList, setDeleteRequestsList] = useState([]);
  const [displayUsers, setDisplayUsers] = useState([]);
  const [openDeleteUser, setOpenDeleteUser] = useState({ status: false, data: null });
  const { authData, setAuthData } = useContext(UserSessionContext);
  const history = useHistory();

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const response = await findAllDeleteRequests(null, authData.accessToken);
      setDeleteRequestsList(response.data);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const filterUsers = (e) => {
    let newDisplayFilters = deleteRequestsList?.filter((row) => row.name.trim().toLowerCase().includes(e.currentTarget.value.toString().trim().toLowerCase()));
    setDisplayUsers(newDisplayFilters);
    if (e.currentTarget.value === '') setDisplayUsers(deleteRequestsList);
    setSearchString(e.currentTarget.value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const removeUserByEmail = async (userData) => {
    try {
      //remove user from the platform and update status of the delete request
      let response = await removeUser({ id_user: userData.data.id_user }, authData.accessToken);
      if (response?.message) {
        setOpenDeleteUser({ status: false, data: null });
        fetchData();
        props.snackbarShowMessage(response.message);
      } else {
        props.snackbarShowErrorMessage(response.error);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const headCells = [
    {
      id: 'usersEmail',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.name,
      isAction: false
    },
    {
      id: 'requestStatus',
      numeric: false,
      disablePadding: false,
      label: 'STATO',
      isAction: false
    },
    {
      id: 'requestDate',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.addingDate,
      isAction: false
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.actions,
      isAction: true
    }
  ];

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  });

  //rendering the profile editing form
  const UserRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <>
        <SpTableRow
          role="checkbox"
          id={row?.group?.id}
          tabIndex={index}
        >
          <SpTableCell>
            <SpText variant="tableText">{row?.name}</SpText>
          </SpTableCell>
          <SpTableCell>
            <SpText variant="tableText">{moment(row.createdAt).format('DD/MM/yyyy')}</SpText>
          </SpTableCell>
          <TableCell
            align={'right'}
            style={{
              padding: 10,
              verticalAlign: 'bottom',
              borderBottom: 0
            }}
          >
            <SpButton
              variant={'standard'}
              type="tableList"
              text={'Conferma eliminazione'}
              onClick={() => {
                setOpenDeleteUser({ status: true, data: row });
              }}
            />
          </TableCell>
        </SpTableRow>
      </>
    );
  };

  return (
    <>
      <Grid
        container
        style={{ paddingLeft: '1%' }}
        direction="column"
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TitleToolbarSection>
            <SpText
              variant="h1"
              style={{ marginRight: '5px' }}
            >{`RICHIESTE DI ELIMINAZIONE`}</SpText>
          </TitleToolbarSection>
        </Grid>
        <Grid
          item
          container
          xs={12}
          direction="row"
          spacing={3}
          alignItems="center"
        >
          <Grid
            item
            xs={7}
          >
            <SpSearch
              onChange={(e) => filterUsers(e)}
              value={searchString}
              searchStyle={{ width: '100%' }}
              style={{ marginRight: '5px' }}
            />
          </Grid>
        </Grid>
        {displayUsers && displayUsers?.length === 0 && (
          <Grid
            container
            item
            xs={12}
            style={{ marginTop: '1%' }}
          >
            <SpText variant="h1PageSubtitle">Non ci sono richieste!</SpText>
          </Grid>
        )}
        {displayUsers && displayUsers?.length > 0 && (
          <Grid
            item
            xs={12}
          >
            <SpTable
              pagination={true}
              headCells={headCells}
              rows={displayUsers}
              rowKey="id"
              padding={false}
              notCheckable={false}
              tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
            >
              <UserRow />
            </SpTable>
          </Grid>
        )}
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={openDeleteUser.status}
        setOpen={() => setOpenDeleteUser({ status: !openDeleteUser.status, data: null })}
        title={'Elimina richieste'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler eliminare la ?'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => removeUserByEmail(openDeleteUser)}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => setOpenDeleteUser(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(UserDeletionRequests);
